// Étapes de la visite guidée (driver.js).
// Les étapes dont l'élément n'est pas présent dans le DOM (route désactivée par
// feature flag, vue mobile, etc.) sont retirées au lancement de la visite.

const menuRoute = (path) => `[data-tour-route="${path}"]`;

export const PRODUCT_TOUR_STEPS = [
  {
    popover: {
      title: 'Bienvenue sur Fleet 👋',
      description:
        'Découvrez en quelques étapes les principaux écrans pour piloter votre flotte au quotidien.',
    },
  },
  {
    element: menuRoute('/'),
    popover: {
      title: 'Tableau de bord',
      description:
        'Votre tour de contrôle : indicateurs clés, réserves non traitées et suivi des véhicules en temps réel.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="dashboard-date-picker"]',
    popover: {
      title: 'Sélection de la date',
      description:
        "Choisissez le jour à consulter : l'ensemble du tableau de bord se met à jour pour cette date.",
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="dashboard-view-toggle"]',
    popover: {
      title: 'Affichage carte / liste',
      description:
        'Basculez entre la liste des véhicules et de leurs tournées, et la carte pour visualiser leur répartition.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: menuRoute('/orders-pool'),
    popover: {
      title: 'Puits de commandes',
      description:
        'Retrouvez toutes les commandes à planifier, sélectionnez-les et envoyez-les en ordonnancement.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: menuRoute('/truck-assignments'),
    popover: {
      title: 'Affectation camion',
      description:
        'Affectez les commandes planifiées à vos camions et organisez le chargement de chaque véhicule.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: menuRoute('/tours'),
    popover: {
      title: 'Tournées',
      description:
        'Consultez la liste de vos tournées, leur avancement et le détail de chaque étape.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: menuRoute('/reserves'),
    popover: {
      title: 'Réserves',
      description:
        'Suivez les réserves remontées par les chauffeurs et traitez-les depuis leur historique.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="dashboard-tour-button"]',
    popover: {
      title: 'Revoir la visite',
      description:
        'Vous pourrez relancer cette visite guidée à tout moment depuis ce bouton.',
      side: 'bottom',
      align: 'end',
    },
  },
];
